import { IContactForm } from "store/entities/contact-forms/interfaces";

function toBinary(text: string): string {
  const codeUnits = new Uint16Array(text.length);
  for (let i = 0; i < codeUnits.length; i += 1) {
    codeUnits[i] = text.charCodeAt(i);
  }
  const charCodes = new Uint8Array(codeUnits.buffer);
  let result = "";
  for (let i = 0; i < charCodes.byteLength; i += 1) {
    result += String.fromCharCode(charCodes[i]);
  }
  return result;
}

function encodeContactFormData(contactFormJSON: string): string {
  return btoa(toBinary(contactFormJSON));
}

export function generatePreview(
  contactForm: Partial<IContactForm>,
  hasPoweredByFooter: boolean,
  version: number = 1
): string {
  const contactFormData = JSON.stringify({ ...contactForm, isEnterprise: !hasPoweredByFooter });
  const queryString = new URLSearchParams();
  queryString.append("previewData", encodeContactFormData(contactFormData));
  queryString.append("isPreview", "1");
  queryString.append("version", version.toString());

  return queryString.toString();
}
